import { Image } from '@skytech/ui/Image'
import { connect } from 'react-redux'

import { hideMonitorSplash, increaseStep, setScreen } from '@/ducks/onboarding/onboardingActions'
import {
  displayMonitorStepSplash,
  getDoubleScreen,
  getScreens,
  getSelectedScreenId,
} from '@/ducks/onboarding/onboardingSelectors'
import DisplayPortImg from '@/images/onboarding/display_port.png'
// @ts-ignore
import DisplayPortCableImg from '@/images/onboarding/display_port_cable.jpg'
import { numberFormat } from '@/util/formatters/numbers'
import {
  OnboardingNextStepIcon,
  OnboardingNotSelectedIcon,
  OnboardingSelectedIcon,
} from '@/util/icons'

import './step-monitors.scss'

const StepMonitor = ({
  products,
  selectedScreenId,
  doubleScreen,
  setScreen,
  increaseStep,
  displayMonitorStepSplash,
  hideMonitorSplash,
}: any) => (
  <div id="step-monitors" className="step">
    <h3>Choose Monitor</h3>

    {displayMonitorStepSplash ? (
      <>
        <p>
          If you have a monitor and don’t need a new one, you must make sure that your current
          monitor have a DisplayPort.
        </p>

        <p>
          If your current monitor have a DisplayPort, but you need cables, you can order them under
          accessories later in this process.
        </p>

        <div className="display-port-images">
          <Image src={DisplayPortImg} alt="Display Port" />
          <Image src={DisplayPortCableImg} alt="Display Port Cable" />
        </div>

        <p>
          If your monitor don’t have a DisplayPort, but it has a HDMI Port, you can order a
          DisplayPort to HDMI plug later in this process under accessories. If you don’t have
          either, and you need a monitor, please choose monitor.
        </p>

        <button onClick={hideMonitorSplash}>Choose monitor</button>
        <button onClick={increaseStep}>
          I don&apos;t need a monitor
          <OnboardingNextStepIcon />
        </button>
      </>
    ) : (
      <>
        <p>All monitors come with DisplayPort cable</p>
        <div className="products">
          {/* @ts-ignore */}
          {products.map(({ id, ...restOfProps }) => (
            // @ts-ignore
            <Product
              key={id}
              setScreen={setScreen}
              isProductSelected={selectedScreenId === id && !doubleScreen}
              id={id}
              doubleScreen={false}
              {...restOfProps}
            />
          ))}
          {/* @ts-ignore */}
          {products.map(({ id, ...restOfProps }) => (
            // @ts-ignore
            <Product
              key={id}
              setScreen={setScreen}
              isProductSelected={selectedScreenId === id && doubleScreen}
              id={id}
              doubleScreen={true}
              {...restOfProps}
            />
          ))}
        </div>

        <button onClick={increaseStep}>
          Choose mouse and keyboard
          <OnboardingNextStepIcon />
        </button>
      </>
    )}
  </div>
)

const Product = ({
  id,
  name,
  specs,
  price,
  imgUrl,
  setScreen,
  isProductSelected,
  doubleScreen,
}: any) => (
  // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
  <div
    onClick={() => setScreen(id, doubleScreen)}
    className={`products__product ${isProductSelected && 'selected'}`}
  >
    <h3>
      {doubleScreen && `2 x `}
      {name}
    </h3>

    <div className="selection">
      {isProductSelected ? <OnboardingSelectedIcon /> : <OnboardingNotSelectedIcon />}
    </div>

    <Image src={imgUrl} alt="product" />

    {doubleScreen && <Image src={imgUrl} alt="product" />}

    <div className="specs">{specs}</div>

    <div className="price">
      Price: <b>{numberFormat(doubleScreen ? price * 2 : price)},-</b>
    </div>
  </div>
)
// @ts-ignore
const mapStateToProps = state => ({
  products: getScreens(state),
  selectedScreenId: getSelectedScreenId(state),
  doubleScreen: getDoubleScreen(state),
  displayMonitorStepSplash: displayMonitorStepSplash(state),
})

const mapDispatchToProps = {
  setScreen,
  increaseStep,
  hideMonitorSplash,
}

export default connect(mapStateToProps, mapDispatchToProps)(StepMonitor)
